import { styled } from "styled-components";

const Container = styled.div`
  position: relative;

  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 1rem 1.5rem;
  flex-grow: 1;
  z-index: 10;
`;

const Title = styled.div`
  display: flex;
  align-self: center;
  gap: 0.5rem;

  font-weight: 900;
  font-size: 1.25rem;
  color: ${({ theme }) => theme.colors.black};
  font-family: ${({ theme }) => theme.fonts.grotesk};
  svg {
    width: 1.6875rem;
    height: 1.6875rem;
  }
`;

const Scores = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

const Networks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  padding: 0.5rem 0.5rem 1rem;

  border-radius: 1rem;
  background: ${({ theme }) => theme.colors.surfaceScores};
`;

const Network = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  padding: 0 0.5rem;

  & > svg {
    width: 1.5rem;
    height: 1.5rem;
  }
`;

const Text = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  & > p {
    &:last-of-type {
      color: ${({ theme }) => theme.colors.greyOp05};
      font-size: 0.75rem;
      font-weight: 500;
      line-height: 120%;
      letter-spacing: -0.015rem;
    }

    &:first-of-type {
      color: ${({ theme }) => theme.colors.black};
      font-family: ${({ theme }) => theme.fonts.manrope};
      font-size: 1rem;
      font-weight: 700;
      line-height: 1.25rem;
    }
  }
`;

const GetNftText = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 1rem;
  flex-direction: column;
  gap: 1rem;
  & > p {
    color: ${({ theme }) => theme.colors.black};
    font-family: ${({ theme }) => theme.fonts.manrope};
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.25rem;
  }
`;

const ScoreAmount = styled.div`
  width: 4.125rem;
  text-align: right;
  & > span {
    line-height: 140%;
    color: ${({ theme }) => theme.colors.black};
    font-weight: 700;
    font-size: 1rem;

    &:last-of-type {
      opacity: 0.5;
    }
  }
`;

const Nft = styled.div<{ $hasNFT: boolean }>`
  position: relative;

  display: flex;

  color: ${({ theme, $hasNFT }) => ($hasNFT ? theme.colors.green : theme.colors.picture)};
  cursor: ${({ $hasNFT }) => ($hasNFT ? "pointer" : "default")};
  & > img {
    width: 1.5rem;
    height: 1.5rem;
  }
`;

const Arrow = styled.div<{ $isOpen: boolean }>`
  position: relative;
  display: flex;
  ${({ $isOpen }) => (!$isOpen ? "transform: rotate(90deg)" : "transform: rotate(270deg)")};
`;

const EmptyBody = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: flex-end;
`;

const Button = styled.button`
  max-width: 120px;
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 19.6px;
  text-align: left;
  color: rgba(44, 48, 52, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background: transparent;
  gap: 8px;
`;

const TotalScore = styled.div`
  display: flex;
  padding: 0 0.5rem;
  height: 2.38rem;
  justify-content: space-between;
  align-items: center;

  border-radius: 0.5rem;
  background: ${({ theme }) => theme.colors.surfaceQuaternary};

  & > p {
    color: ${({ theme }) => theme.colors.black};
    font-family: ${({ theme }) => theme.fonts.grotesk};
    font-size: 1.125rem;
    font-style: normal;
    font-weight: 900;
    line-height: normal;

    &:first-of-type {
      color: ${({ theme }) => theme.colors.black};
    }

    &:last-of-type {
      color: ${({ theme }) => theme.colors.orangeSecondary};
      -webkit-text-stroke: 1px ${({ theme }) => theme.colors.black};
      text-shadow: 1px 1px 0px ${({ theme }) => theme.colors.black};

      font-weight: 900;
      font-size: 1.5rem;
      line-height: 116%;
    }
  }
`;

const CanvasBorder = styled.div`
  border: 1px solid rgba(199, 186, 184, 1);
  border-radius: 1rem;
`;

export default {
  GetNftText,
  Container,
  Title,
  Scores,
  Networks,
  Network,
  ScoreAmount,
  Nft,
  Text,
  TotalScore,
  Button,
  EmptyBody,
  CanvasBorder,
  Arrow,
};
